import { useNavigate } from 'react-router-dom';

export default function TopKunden({ kunden }) {
  const navigate = useNavigate();

  if (!kunden || kunden.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        Keine Daten verfügbar
      </div>
    );
  }

  const maxUmsatz = Math.max(...kunden.map(k => k.umsatz));

  return (
    <div className="space-y-3">
      {kunden.map((k, index) => {
        const prozent = (k.umsatz / maxUmsatz) * 100;

        return (
          <div
            key={k.kunde?.id || index}
            onClick={() => k.kunde && navigate(`/kunden/${k.kunde.id}`)}
            className="group cursor-pointer hover:bg-gray-50 rounded-lg p-3 transition"
          >
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-3">
                <div className="flex items-center justify-center w-8 h-8 bg-primary text-white rounded-full font-bold text-sm">
                  {index + 1}
                </div>
                <div>
                  <p className="font-medium text-gray-900 group-hover:text-primary transition">
                    {k.kunde?.name || 'Unbekannt'}
                  </p>
                  <p className="text-xs text-gray-500">
                    {k.anzahlRechnungen} Rechnung{k.anzahlRechnungen !== 1 ? 'en' : ''}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="font-bold text-gray-900">
                  {k.umsatz.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}€
                </p>
              </div>
            </div>

            {/* Progress Bar */}
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-primary h-2 rounded-full transition-all duration-500"
                style={{ width: `${prozent}%` }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
